/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject";
import InvoiceItem from "@shared/Invoice/InvoiceItem";


export default class LockerState extends DbBaseObject{

	hasPaymentLocker = false
	isLockedByPayment = false
	paymentAmount = 0
	invoiceItem: InvoiceItem = null
	invoiceGroupId: string = null
	billingDataId: string = null
	billingItemIds: string[] = []

	constructor() {
		super();
	}

	isLocked(){
		return this.isLockedByPayment && this.paymentAmount > 0
	}

	reset(){
		this.invoiceGroupId = null
	}

	fillFromInvoice(invoiceItem){
		this.invoiceGroupId = invoiceItem.id
		this._fillFromBillingDataInternal(invoiceItem.billingData)
	}

	_fillFromBillingDataInternal(billingData){
		let totalAmount = 0
		let itemIds = []
		for(let billingItem of billingData.billingItems){
			totalAmount += billingItem.amount
			itemIds.push(billingItem.id)
		}
		this.paymentAmount = totalAmount
		this.billingItemIds = itemIds
		this.billingDataId = billingData.id
		if(totalAmount > 0){
			this.hasPaymentLocker = true
			this.isLockedByPayment = true
		}
	}

}



